module.exports = __webpack_public_path__ + "static/media/icon_trend-up.ac0f67f6.svg";